import React from "react";

// ── Secondary landing page: Furloop Poofed — verified data erasure ──
// Content generated from poofed-landing.md, built on the existing landing design system.
import EraseHero from "./erasure/EraseHero";
import WhyErasure from "./erasure/WhyErasure";
import ErasureMethods from "./erasure/ErasureMethods";
import AutomatedWorkflow from "./erasure/AutomatedWorkflow";
import Certificate from "./erasure/Certificate";
import Compliance from "./erasure/Compliance";
import VsLegacy from "./erasure/VsLegacy";
import FullCycle from "./erasure/FullCycle";
import Pricing from "./erasure/Pricing";
import EraseFaq from "./erasure/EraseFaq";
import EraseRegister from "./erasure/EraseRegister";

function DataErasure() {
  return (
    <div className="bg-brand-bg">
      <EraseHero />
      <WhyErasure />
      <ErasureMethods />
      <AutomatedWorkflow />
      <Certificate />
      <Compliance />
      <VsLegacy />
      <FullCycle />
      <Pricing />
      <EraseFaq />
      <EraseRegister />
    </div>
  );
}

export default DataErasure;
